import { Userpilot } from "userpilot";
import { Tab } from "./types";

export const getMenuNavigation = (operatorId: string) => {
  const navigation: Tab[] = [
    {
      name: "Bookings",
      to: "/bookings",
      icon: "ArchiveBook",
      badge: "16",
      permission: ["manage", "providerClient"],
    },
    {
      name: "Vehicles",
      to: "/vehicles",
      legacyTo: `/o/${operatorId}/config/vehicle-manager`,
      icon: "Car",
      badge: "4",
      permission: ["manage", "providerVehicleManager"],
      legacyPermission: ["manage", "legacyProviderVehicleManager"],
    },
    {
      name: "Drivers",
      to: "/drivers",
      icon: "UserSquare",
      badge: "12",
      permission: ["manage", "providerDriver"],
    },
    {
      name: "Clients",
      to: "/clients",
      icon: "Profile2User",
      badge: "5",
      permission: ["manage", "providerClient"],
    },
    {
      name: "Payments",
      to: "/payments",
      icon: "DollarCircle",
      permission: ["view", "providerPayments"],
    },
  ];

  return navigation;
};

export const getMoreNavigation = () => {
  const navigation: Tab[] = [
    {
      name: "Private Network",
      to: "/private-network",
      icon: "Global",
      permission: ["manage", "providerPrivateNetwork"],
    },
    {
      name: "External Suppliers",
      to: "/external-suppliers",
      icon: "People",
      badge: "5",
      permission: ["manage", "providerExternalSupplier"],
    },
    {
      name: "Companies",
      to: "/companies",
      icon: "Buildings",
      permission: ["view", "providerCompany"],
    },
    // {
    //   name: "Accreditations",
    //   to: "/accreditations",
    //   icon: "LikeTag",
    //   permission: ["manage", "providerAccreditations"],
    //   isDashboard: true,
    // },
    {
      name: "Rating Manager",
      to: "/rating-manager",
      icon: "Star1",
      permission: ["manage", "providerRatingDriver"],
    },
    {
      name: "Trip Reporting",
      to: "/trip-reporting",
      icon: "DocumentText",
      permission: ["manage", "providerReportingTrip"],
    },
    {
      name: "Settings",
      to: "/config",
      icon: "Setting2",
      permission: ["view", "providerConfig"],
    },
    {
      name: "Help",
      icon: "Lifebuoy",
      to: "",
      onClick: () => Userpilot.trigger("resource_center:6M4ZcjVqyD"),
    },
  ];

  return navigation;
};
